import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '#app/utils/tailwind-merge.ts'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

const Input = forwardRef<HTMLInputElement, InputProps>(
	({ className, type, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					`relative flex h-10 w-full rounded-full border border-brand-grey-light-1 bg-transparent px-3 py-2 text-sm [color-scheme:dark] file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-brand-muted-amethyst disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid]:border-danger-border [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:right-4 [&::-webkit-calendar-picker-indicator]:cursor-pointer`,
					className,
				)}
				{...props}
				ref={ref}
			/>
		)
	},
)
Input.displayName = `Input`

export { Input }
